document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  const productJsonEl = document.querySelector('script[data-js-product-json]');
  if (!productJsonEl) return;

  const product = JSON.parse(productJsonEl.textContent);
  const allVariants = product.variants;

  const MULTI_SELECT_PRODUCT_IDS = [10321551786265];
  const MULTI_SELECT_OPTION = 'Luxury Gift Box';
  const MULTI_SELECT_COUNT = 4;

  const isMultiSelectProduct = MULTI_SELECT_PRODUCT_IDS.includes(product.id);
  let selectedScents = [];

  // ─── SHARED: Variant filtering (runs on ALL products) ───────────────────────

  function updateOption2Visibility() {
    if (isMultiSelectProduct && isMultiSelectMode()) return;
    const selectedOption1 = form.querySelector('input[name="option1"]:checked')?.value;
    if (!selectedOption1) return;

    const availableOption2 = allVariants
      .filter(v => v.option1 === selectedOption1 && v.available)
      .map(v => v.option2);

    form.querySelectorAll('input[name="option2"]').forEach(input => {
      const wrapper = input.closest('.radio-option');
      const isAvailable = availableOption2.includes(input.value);
      input.disabled = !isAvailable;
      if (wrapper) wrapper.classList.toggle('line', !isAvailable);
      if (wrapper) wrapper.classList.toggle('visually-hidden', !isAvailable);
    });
  }

  // ─── MUSK PACKAGE ONLY: Multi-select logic ──────────────────────────────────

  const counter = document.createElement('div');
  counter.id = 'scent-counter';
  counter.style.cssText = 'margin: 8px 0; font-size: 14px; color: #937A70; display: none;';

  function getCurrentPackaging() {
    return form.querySelector('input[name="option1"]:checked')?.value;
  }

  function isMultiSelectMode() {
    return isMultiSelectProduct && getCurrentPackaging() === MULTI_SELECT_OPTION;
  }

  function injectCounter() {
    const option2Fieldset = form.querySelector('input[name="option2"]')?.closest('fieldset');
    if (option2Fieldset && !document.getElementById('scent-counter')) {
      option2Fieldset.parentElement.insertBefore(counter, option2Fieldset);
    }
  }

  function updateCounter() {
    counter.textContent = `${selectedScents.length}/${MULTI_SELECT_COUNT} scents selected`;
    counter.style.display = isMultiSelectMode() ? 'block' : 'none';
  }

  function getLabelForInput(input) {
    return form.querySelector(`label[for="${input.id}"]`) || input.closest('.radio-option')?.querySelector('.radio-option__label');
  }

  function resetMultiSelect() {
    selectedScents = [];
    form.querySelectorAll('input[name="option2"]').forEach(input => {
      input.checked = false;
      input.disabled = false;
      const wrapper = input.closest('.radio-option');
      const label = getLabelForInput(input);
      if (wrapper) wrapper.classList.remove('visually-hidden', 'line');
      if (label) {
        label.classList.remove('multi-selected');
        label.style.backgroundColor = '';
        label.style.color = '';
        label.style.borderColor = '';
      }
    });
  }

  function applyMultiSelectState() {
    form.querySelectorAll('input[name="option2"]').forEach(input => {
      const wrapper = input.closest('.radio-option');
      const label = getLabelForInput(input);
      const isSelected = selectedScents.includes(input.value);
      const isFull = selectedScents.length >= MULTI_SELECT_COUNT;

      input.checked = isSelected;
      input.disabled = !isSelected && isFull;

      if (wrapper) wrapper.classList.toggle('line', !isSelected && isFull);

      if (label) {
        if (isSelected) {
          label.style.backgroundColor = '#A17B4B';
          label.style.color = '#fff';
          label.style.borderColor = '#A17B4B';
        } else {
          label.style.backgroundColor = '';
          label.style.color = '';
          label.style.borderColor = '';
        }
      }
    });
    updateCounter();
  }

  function handleMultiSelectClick(input) {
    const value = input.value;
    if (selectedScents.includes(value)) {
      selectedScents = selectedScents.filter(s => s !== value);
    } else {
      if (selectedScents.length >= MULTI_SELECT_COUNT) return;
      selectedScents.push(value);
    }
    applyMultiSelectState();
    updateCartProperties();
  }

  function updateCartProperties() {
    let propInput = form.querySelector('input[name="properties[Selected Scents]"]');
    if (!propInput) {
      propInput = document.createElement('input');
      propInput.type = 'hidden';
      propInput.name = 'properties[Selected Scents]';
      form.appendChild(propInput);
    }
    propInput.value = selectedScents.join(', ');
  }

  function switchToSingleSelect() {
    resetMultiSelect();
    counter.style.display = 'none';
    setTimeout(updateOption2Visibility, 50);
  }

  function switchToMultiSelect() {
    resetMultiSelect();
    injectCounter();
    updateCounter();
    form.querySelectorAll('input[name="option2"]').forEach(input => {
      input.disabled = false;
      const wrapper = input.closest('.radio-option');
      if (wrapper) wrapper.classList.remove('visually-hidden', 'line');
    });
  }

  // ─── EVENT LISTENERS ────────────────────────────────────────────────────────

  if (isMultiSelectProduct) {
    form.addEventListener('click', function (e) {
      if (!isMultiSelectMode()) return;

      // Target clicks on the label or anything inside .radio-option for option2
      const wrapper = e.target.closest('.radio-option');
      if (!wrapper) return;

      const input = wrapper.querySelector('input[name="option2"]');
      if (!input) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      handleMultiSelectClick(input);
    }, true);
  }

  form.addEventListener('change', function (e) {
    if (e.target.name === 'option1') {
      setTimeout(() => {
        if (isMultiSelectMode()) {
          switchToMultiSelect();
        } else if (isMultiSelectProduct) {
          switchToSingleSelect();
        } else {
          updateOption2Visibility();
        }
      }, 50);
    }
    if (e.target.name === 'option2' && !isMultiSelectMode()) {
      setTimeout(updateOption2Visibility, 50);
    }
  });

  // ─── INIT ────────────────────────────────────────────────────────────────────

  setTimeout(() => {
    if (isMultiSelectProduct) injectCounter();
    if (isMultiSelectMode()) {
      switchToMultiSelect();
    } else {
      updateOption2Visibility();
    }
  }, 100);
});
